module.exports = {
  "dof-lottery-rain": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "right": 0,
    "bottom": 0,
    "backgroundColor": "rgba(133,11,11,0.8)"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-68639031!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-lottery-rain/index.vue
// module id = 496
// module chunks = 0 1